import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

export default function ClearFilters({
  handleClear,
  variant = 'danger',
  extraClasses = '',
  label = 'Clear filters',
  tooltip = label,
}) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <Button
        variant="link"
        className={`clear-filters-btn custom-btn-link text-decoration-none text-${variant} ${extraClasses} fs-7 fs-msm-6 fw-semibold`}
        onClick={handleClear}
      >
        <FaTimes size={18} />
        <span className="clear-filters-label">{label}</span>
      </Button>
    </OverlayTrigger>
  );
}
